import { BroadcastMessage } from '@aipb/env/model';
import { Injectable } from '@angular/core';
import { addSeconds } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
import { isInDateRange } from './broadcast-message.util';

const COOKIE_PATH = '/';
const COOKIE_KEY = 'broadcast_message';

@Injectable({
  providedIn: 'root'
})
export class BroadcastMessageService {
  // @ts-expect-error foo
  private _broadcastMessage: BroadcastMessage;
  private _active = new BehaviorSubject(false);
  public active$ = this._active.asObservable();
  // @ts-expect-error foo
  private _timeout;
  // @ts-expect-error foo
  private _hash: string;

  constructor(private cookieService: CookieService) {}

  get dismissExpiration(): number {
    return this._broadcastMessage.dismissExpiration || 60 * 60 * 24;
  }

  get duration(): number {
    return this._broadcastMessage.duration || 15000;
  }

  init(broadcastMessage: BroadcastMessage): void {
    if (!broadcastMessage) return;

    this._broadcastMessage = broadcastMessage;
    this._hash = JSON.stringify(broadcastMessage);

    const shouldBeDisplayed = this.shouldBeDisplayed();

    this._active.next(shouldBeDisplayed);

    if (shouldBeDisplayed) {
      this._timeout = setTimeout(() => {
        // Just deactivate without writing to cookies
        this._active.next(false);
      }, this.duration);
    }
  }

  // Deactivate via user interaction + write it to cookies
  close(): void {
    this._active.next(false);
    this.markAsDismissed();

    if (this._timeout) {
      clearTimeout(this._timeout);
    }
  }

  shouldBeDisplayed() {
    return this.isInDateRange() && !this.isAlreadyDismissed();
  }

  isAlreadyDismissed(): boolean {
    const hash = this.cookieService.get(COOKIE_KEY);
    return this._hash === hash;
  }

  isInDateRange(): boolean {
    const fromDate = this._broadcastMessage.fromDate ? new Date(this._broadcastMessage.fromDate) : undefined;
    const toDate = this._broadcastMessage.toDate ? new Date(this._broadcastMessage.toDate) : undefined;
    const now = zonedTimeToUtc(new Date(), 'UTC');

    return isInDateRange({ now, fromDate, toDate });
  }

  private markAsDismissed(): void {
    this.cookieService.set(COOKIE_KEY, this._hash, addSeconds(new Date(), this.dismissExpiration), COOKIE_PATH);
  }
}
